import { getList as _getList, getOneById as _getOneById, getAll as _getAll } from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/forms";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "code",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 10,
};

function normalizeFormData(data) {
    const { expires: expiresInMillis } = data;

    const expires = new Date(expiresInMillis);

    return {
        ...data,
        expires,
        expiresString: dateToString(expires, false),
    };
}

function normalizeData(data) {
    return data.map(normalizeFormData);
}

export function getAll({ onSuccess, onError }) {
    _getAll({
        url: BASE_URL,
        onSuccess,
        onError,
        normalizer: normalizeData,
        data: { filter: { isCurrent: true }, orderBy: "code", orderDirection: "asc" },
    });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeFormData,
    });
}
